import React from "react";
import CreateVisitorForm from "../../Modal/CreateVisitorForm";
import {getPrivacyConsent} from "../../External/Model/Model";

/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */

const CreateVisitorProfileForm = ({
    t,
    userData,
    handleChangeVisitor,
    handleChange,
    emptyFieldsVisitor,
    isValidEmail,
    isValidPhoneNumber,
    handleEmailChange,
    handlePhoneNumberChange,
    setUserData,
    requestAccessItem
}) => {

    return (
        <>
            <div className="row background-general-00 box-shadow-primary-900-opacity-10 p-24px border-radius-8px">
                <div className={"row"}>
                    <p className={"fs-24-to-18 ibl-font-w-600 font-color-general-950 text-capitalize text-center mb-3"}>{t("create_your_profile")}</p>
                    <p className="fs-20-to-14 ibl-font-w-400 font-color-general-950 text-center mb-5">{t("we_will_use_this_to_contact_you_about_your_request")}</p>
                </div>
                <div className={"row"}>
                    <CreateVisitorForm
                        userData={userData}
                        setUserData={setUserData}
                        disabled={false}
                        handleChange={handleChangeVisitor}
                        handleEmailChange={handleEmailChange}
                        handlePhoneNumberChange={handlePhoneNumberChange}
                        emptyFields={emptyFieldsVisitor}
                        isValidEmail={isValidEmail}
                        isValidPhoneNumber={isValidPhoneNumber}
                    />
                </div>
                <div className={"col-12"}>
                    <div className={"d-flex"}>
                        { getPrivacyConsent("cb_cvp_privacy_consent", requestAccessItem?.privacyConsent, handleChange, false) }
                    </div>
                </div>
            </div>
        </>
    );
};
export default CreateVisitorProfileForm
